module.exports = __webpack_public_path__ + "img/ktb-3.79b8c39f.png";